import { Subject } from 'rxjs';
import { BaseComponent } from '../components/base.component';
import { Input } from '@angular/core';

export class BaseModal extends BaseComponent {

    private subject: Subject<any>;

    action(value: any): void {
        this.subject.next(value);
        this.subject.complete();
    }
}
